import _slicedToArray from "D:\\MyProjects\\my-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "D:\\MyProjects\\my-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "D:\\MyProjects\\my-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\MyProjects\\my-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

/**
 * Copyright IBM Corp. 2015, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
var enabled$1 = {};

try {
  if (process.env.CARBON_ENABLE_CSS_CUSTOM_PROPERTIES) {
    if (process.env.CARBON_ENABLE_CSS_CUSTOM_PROPERTIES === 'true') {
      enabled$1.enableCssCustomProperties = true;
    } else {
      enabled$1.enableCssCustomProperties = false;
    }
  } else {
    enabled$1.enableCssCustomProperties = false;
  }

  if (process.env.CARBON_ENABLE_USE_CONTROLLED_STATE_WITH_VALUE) {
    if (process.env.CARBON_ENABLE_USE_CONTROLLED_STATE_WITH_VALUE === 'true') {
      enabled$1.enableUseControlledStateWithValue = true;
    } else {
      enabled$1.enableUseControlledStateWithValue = false;
    }
  } else {
    enabled$1.enableUseControlledStateWithValue = false;
  }

  if (process.env.CARBON_ENABLE_CSS_GRID) {
    if (process.env.CARBON_ENABLE_CSS_GRID === 'true') {
      enabled$1.enableCssGrid = true;
    } else {
      enabled$1.enableCssGrid = false;
    }
  } else {
    enabled$1.enableCssGrid = false;
  }

  if (process.env.CARBON_ENABLE_V11_RELEASE) {
    if (process.env.CARBON_ENABLE_V11_RELEASE === 'true') {
      enabled$1.enableV11Release = true;
    } else {
      enabled$1.enableV11Release = false;
    }
  } else {
    enabled$1.enableV11Release = false;
  }
} catch (error) {
  enabled$1.enableCssCustomProperties = false;
  enabled$1.enableUseControlledStateWithValue = false;
  enabled$1.enableCssGrid = false;
  enabled$1.enableV11Release = false;
}

var featureFlagInfo = [{
  name: "enable-css-custom-properties",
  description: "Describe what the flag does",
  enabled: enabled$1.enableCssCustomProperties
}, {
  name: "enable-use-controlled-state-with-value",
  description: "Enable components to be created in either a controlled or uncontrolled mode\n",
  enabled: enabled$1.enableUseControlledStateWithValue
}, {
  name: "enable-css-grid",
  description: "Enable CSS Grid Layout in the Grid and Column React components\n",
  enabled: enabled$1.enableCssGrid
}, {
  name: "enable-v11-release",
  description: "Enable the features and functionality for the v11 Release\n",
  enabled: enabled$1.enableV11Release
}];

var FeatureFlagScope = /*#__PURE__*/function () {
  function FeatureFlagScope(flags) {
    var _this = this;

    _classCallCheck(this, FeatureFlagScope);

    this.flags = new Map();

    if (flags) {
      Object.keys(flags).forEach(function (key) {
        _this.flags.set(key, flags[key]);
      });
    }
  }
  /**
   * Check to see if a flag exists
   * @param {string} name
   */


  _createClass(FeatureFlagScope, [{
    key: "checkForFlag",
    value: function checkForFlag(name) {
      if (!this.flags.has(name)) {
        throw new Error("Unable to find a feature flag with the name: `".concat(name, "`"));
      }
    }
    /**
     * Add a feature flag
     * @param {string} name
     * @param {boolean} enabled
     */

  }, {
    key: "add",
    value: function add(name, enabled) {
      if (this.flags.has(name)) {
        throw new Error("The feature flag: ".concat(name, " already exists"));
      }

      this.flags.set(name, enabled);
    }
    /**
     * Enable a feature flag
     * @param {string} name
     */

  }, {
    key: "enable",
    value: function enable(name) {
      this.checkForFlag(name);
      this.flags.set(name, true);
    }
    /**
     * Disable a feature flag
     * @param {string} name
     */

  }, {
    key: "disable",
    value: function disable(name) {
      this.checkForFlag(name);
      this.flags.set(name, false);
    }
    /**
     * Merge the given feature flags with the current set of feature flags.
     * Duplicate keys will be set to the value in the given feature flags.
     * @param {object} flags
     */

  }, {
    key: "merge",
    value: function merge(flags) {
      var _this2 = this;

      Object.keys(flags).forEach(function (key) {
        _this2.flags.set(key, flags[key]);
      });
    }
    /**
     * @param {FeatureFlagScope} scope
     */

  }, {
    key: "mergeWithScope",
    value: function mergeWithScope(scope) {
      var _iterator = _createForOfIteratorHelper(scope.flags),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (this.flags.has(key)) {
            continue;
          }

          this.flags.set(key, value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Check if a feature flag is enabled
     * @param {string} name
     * @returns {boolean}
     */

  }, {
    key: "enabled",
    value: function enabled(name) {
      this.checkForFlag(name);
      return this.flags.get(name);
    }
  }]);

  return FeatureFlagScope;
}();

var FeatureFlags = createScope();

for (var i = 0; i < featureFlagInfo.length; i++) {
  var featureFlag = featureFlagInfo[i];
  FeatureFlags.add(featureFlag.name, featureFlag.enabled);
}

function createScope(flags) {
  return new FeatureFlagScope(flags);
}

function add() {
  return FeatureFlags.add.apply(FeatureFlags, arguments);
}

function enable() {
  return FeatureFlags.enable.apply(FeatureFlags, arguments);
}

function disable() {
  return FeatureFlags.disable.apply(FeatureFlags, arguments);
}

function enabled() {
  return FeatureFlags.enabled.apply(FeatureFlags, arguments);
}

function merge() {
  return FeatureFlags.merge.apply(FeatureFlags, arguments);
}

export { FeatureFlags, add, createScope, disable, enable, enabled, merge };